import { Fragment, useState } from "react";
import styled from "styled-components";
import Message from "../Message";
import Modal from "../../modals/Modal";
import { useConfig } from "../../../hooks";
import Feature from "./Feature";
import WinLines from "./WinLines";
import Header from "./Header";
import Symbols from "./Symbols";
import Spinner from "../../Spinner";

const StyledSection = styled.div`
  display: flex;
  justify-content: center;
  padding: 1.5em 0.2em 6em 0.2em;

  @media screen and (max-width: 550px) {
    flex-wrap: wrap;
  }

  ${(props: any) => props.customStyle || ""}
` as any;

type SectionType = {
  title: string;
  style?: string;
  styleHeader?: string;
  data: any[];
};
const Section: React.FC<SectionType> = ({
  title,
  data,
  style,
  styleHeader,
}) => {
  var header = title ? (
    <Header title={title} customStyle={styleHeader ?? ""} />
  ) : (
    ""
  );
  return (
    <Fragment>
      {header}
      <StyledSection customStyle={style}>
        {data.map((d, i) => {
          if (d.type === "symbols") return <Symbols key={i} {...d} />;
          if (d.type === "lines") return <WinLines key={i} {...d} />;

          return <Feature key={i} {...d} />;
        })}
      </StyledSection>
    </Fragment>
  );
};

const StyledPays = styled.div`
  padding: 2em 0;
  display: ${(props: any) => (!props.loaded ? "none" : "initial")};
` as any;

const Pays: React.FC<{ shown?: boolean }> = ({ shown }) => {
  const { paytable: config } = useConfig();
  const [loaded, setLoaded] = useState(false);
  const [count, setCount] = useState(0);

  if (!config || !config.sections) {
    return (
      <Message
        shown={shown}
        icon="Info"
        message="No Paytable available, Please refresh!"
        onClose={() => window.location.reload()}
      />
    );
  }

  // NOTE: The "imagesToLoad" has to be set manually in the game config file,
  // which is deinately not the best aproach but I was not able to find a better way,
  // to know /in advance/ the amount of images that is going to be loaded in the paytable
  const imagesToLoad = config.imagesToLoad ?? 0;
  const onLoad = () => {
    if (!loaded && count + 1 >= imagesToLoad) {
      setLoaded(true);
    }

    setCount(count + 1);
  };

  return (
      <Modal
        className="paytable fullscreen no-titlebar"
        background={config.background}
        shown={shown}
        onHideEnd={() => setCount(0)}
      >
        <Spinner name="paytable" full={true} visible={!loaded} />
        <StyledPays loaded={loaded} onLoad={onLoad}>
          {config.sections.map((section: any, i: number) => {
            return (
              <Section
                key={i}
                title={section.name}
                style={section.style}
                styleHeader={section.styleHeader}
                data={section.data}
              />
            );
          })}
        </StyledPays>
      </Modal>
  );
};

export default Pays;
